import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import cn from 'classnames';
import { Chip } from '../Chip';
import classes from './ChipCollection.module.scss';
export function ChipCollection(props) {
    const { options, extras, testId, className, mode, value, onChange } = props;
    const isSelected = useCallback((key)=>{
        if (mode === 'single') {
            return value === key;
        }
        return value.includes(key);
    }, [
        mode,
        value
    ]);
    const handleClick = useCallback((key)=>{
        if (mode === 'single') {
            onChange(key);
            return;
        }
        const arr = value;
        const next = arr.includes(key) ? arr.filter((k)=>k !== key) : [
            ...arr,
            key
        ];
        onChange(next);
    }, [
        mode,
        value,
        onChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(classes.root, className),
        role: "group",
        "data-testid": testId,
        children: [
            options.map((option)=>{
                var _option_testId;
                return /*#__PURE__*/ _jsx(Chip, {
                    label: option.label,
                    icon: option.icon,
                    ariaLabel: option.ariaLabel,
                    selected: isSelected(option.key),
                    onClick: ()=>handleClick(option.key),
                    disabled: option.disabled,
                    testId: (_option_testId = option.testId) !== null && _option_testId !== void 0 ? _option_testId : testId ? "".concat(testId, "-").concat(option.key) : undefined
                }, option.key);
            }),
            extras
        ]
    });
}
